import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import cleanDeep from 'clean-deep'

class Printer {
  static getPrinters (place) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/impresora`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  };

  static imprimirEtiquetaIngreso ({ numero, impresora, reimpresion = false } = {}) {
    const axios = getAxiosInstance()
    const promise = axios.post(`carta_de_porte_automotor_ingreso_oblea_calado`,
      cleanDeep({ valores: { impresora, numero, reimpresion } }))
    return promise.then(result => {
      const { data } = result
      return data['impreso']
    })
  }

  static imprimirTicketDescarga (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`imprimir_ticket_de_descarga?r=` +
    `{"parametros": {"numerocpe": ${numero}}}`)
    return promise.then(result => {
      const { data } = result
      return data['impreso']
    })
  }

  static reimprimirTicketDescarga (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`reimprimir_ticket_de_descarga?r=` +
    `{"parametros": {"numerocpe": ${numero}}}`)
    return promise.then(result => {
      const { data } = result
      return data['impreso']
    })
  }

  static imprimirTicketDescargaEnImpresora (numero, impresora, marcaDeAgua = '') {
    const axios = getAxiosInstance()
    const promise = axios.get(`imprimir_ticket_de_descarga_en_impresora?r=` +
    `{"parametros": {"numerocpe": ${numero}, "impresora": "${impresora}", "marca_de_agua": "${marcaDeAgua}"}}`)
    return promise.then(result => {
      const { data } = result
      return data['impreso']
    })
  }

  static reimprimirTicketDescargaCerealAdherido (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`registrarcerealadherido?r=` +
    `{"parametros": {"numerocpe": ${numero}}}`)
    return promise.then(result => {
      const { data } = result
      return data['impreso']
    })
  }
}

export default Printer
